
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.49 20.49L3.51 3.51003C3.12 3.12003 2.49 3.12003 2.1 3.51003C1.71 3.90003 1.71 4.53003 2.1 4.92003L3.66 6.48003C2.41 8.36003 1.78 10.69 2.07 13.18C2.6 17.72 6.28 21.4 10.81 21.92C13.3 22.21 15.62 21.58 17.51 20.33L19.07 21.89C19.46 22.28 20.09 22.28 20.48 21.89C20.88 21.51 20.88 20.88 20.49 20.49ZM9.88 15.89L7.05 13.06C6.66 12.67 6.66 12.04 7.05 11.65C7.44 11.26 8.07 11.26 8.46 11.65L10.58 13.77L10.76 13.59L12.17 15L11.29 15.88C10.9 16.28 10.27 16.28 9.88 15.89ZM13.59 10.76L6.49 3.66003C8.37 2.41003 10.7 1.78003 13.19 2.07003C17.73 2.60003 21.41 6.28003 21.93 10.81C22.22 13.3 21.59 15.63 20.34 17.51L15 12.17L16.94 10.23C17.33 9.84003 17.33 9.21003 16.94 8.82003C16.55 8.43003 15.92 8.43003 15.53 8.82003L13.59 10.76Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-unpublished`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconUnpublished

    ```js
    <b-new-b-icon-unpublished />
    ```
</docs>


